import type { BarChartData, GroupedValues } from "@/model/chart";
import color from "@/model/color.module.scss";

const totalWidth = 100;

export function createBarChartData<K, T, E>(
  values: GroupedValues<K, T>,
  enrichFn: (key: K, value: { value: number } & T) => E,
): BarChartData<K, E> | BarChartData<string, never> {
  const total = [...values.values()].reduce((sum, item) => sum + item.value, 0);

  if (total <= 0) {
    return {
      total: 0,
      items: [{ key: "", value: 0, color: "", x: 0, width: totalWidth }],
    } as BarChartData<string, never>;
  }
  const res: BarChartData<K, E> = { total, items: [] };
  let width = totalWidth;
  values.forEach((value, key) => {
    if (width >= 0.01) {
      res.items.push({
        key,
        value: value.value,
        color: color.ok,
        x: 0,
        width: Math.round(width),
        ...enrichFn(key, value),
      });
    }
    width -= (totalWidth * value.value) / total;
  });
  return res;
}
